import apiAuth from "@/services/api.auth";

const state = {
    allClients: [],
    isLoadingAllClients: false
}

export const mutationTypes = {
    allClientsStart: '[auth] All clients start',
    allClientsSuccess: '[auth] All clients success',
    allClientsFailure: '[auth] All clients failure',

}

export const actionTypes = {
    getAllClients: '[auth] Get all clients'
}

export const getterTypes = {
    allClients: '[auth] All clients',
    isLoadingAllClients: '[auth] Is loading all clients'
}

const getters = {
    [getterTypes.allClients]: (state) => {
        return state.allClients
    },
    [getterTypes.isLoadingAllClients]: (state) => {
        return state.isLoadingAllClients
    }
}

const mutations = {
    [mutationTypes.allClientsStart](state) {
        state.isloadingAllClients = true
    },
    [mutationTypes.allClientsSuccess](state, payload) {
        state.isLoadingAllClients = false
        state.allClients = payload.map(c => ({
            ...c,
            active: false
        }))

        // console.log('state.allClients', state.allClients)
    },
    [mutationTypes.allClientsFailure](state) {
        state.isLoadingAllClients = false
    }
}

const actions = {
    [actionTypes.getAllClients](context) {
        return new Promise((resolve, reject) => {
            context.commit(mutationTypes.allClientsStart)
            apiAuth
                .allClients()
                .then((response) => {
                    context.commit(mutationTypes.allClientsSuccess, response.data)
                    resolve(response)
                })
                .catch((result) => {
                    context.commit(mutationTypes.allClientsFailure)
                    reject(result)
                })
        })
    },
}

export default {
    state,
    actions,
    mutations,
    getters,
}
